import React, { useEffect, useState } from "react";
import { Table, Card, Tag } from "antd";
import { FaTools } from "react-icons/fa";
import { getServiceCentersList } from "../../../services/apiService";

const AllServiceCenters = () => {
 const[data , setData] = useState([])
 const [loading , setLoading] = useState(false)
   const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pag) => {
    setPagination(pag);
  };
   useEffect(() => {
    fetchServiceCenters();
  }, []);

  const fetchServiceCenters = async () => {
    try {
      setLoading(true);
      const res = await getServiceCentersList();
      setData(res.data || []);
      console.log(res);
    } catch (error) {
      console.error("Warranty list error:", error);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      title: "Service Center Name",
      dataIndex: "firmname",
      key: "serviceCenterName",
    },
    // {
    //   title: "Service Type",
    //   dataIndex: "extra2",
    //   key: "ownerName",
    // },
    // {
    //   title: "Area",
    //   render: (_, record) => record?.dtl?.[0]?.area || "-",
    //   key: "id",
    // },
    {
      title: "City",
      render: (_, record) => record?.dtl?.[0]?.city || "-",
      key: "id",
    },
    {
      title: "State",
      render: (_, record) => record?.dtl?.[0]?.state || "-",
      key: "id",
    },
     {
      title: "Mobile No",
      dataIndex: "mobile",
      key: "mobileNo",
    },
    {
      title: "FlatNo",
      render: (_, record) => record?.dtl?.[0]?.flathouse || "-",
      key: "id",
    },
    {
      title: "Street",
      render: (_, record) => record?.dtl?.[0]?.area || "-",
      key: "streetName",
    },
    {
      title: "Pincode",
      render: (_, record) => record?.dtl?.[0]?.pincode || "-",
      key: "landmark",
    },
   
    // {
    //   title: "Alt Mobile",
    //   dataIndex: "altMobileNo",
    //   key: "altMobileNo",
    // },
    // {
    //   title: "Landline",
    //   dataIndex: "landlineNo",
    //   key: "landlineNo",
    // },
    // {
    //   title: "Latitude",
    //   dataIndex: "latitude",
    //   key: "latitude",
    // },
    // {
    //   title: "Longitude",
    //   dataIndex: "longitude",
    //   key: "longitude",
    // },
  ];

 

  return (
    <Card
      title={
        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <FaTools /> Service Centers
        </span>
      }
      style={{ margin: "20px" }}
    >     <div
    style={{
      width: "80vw",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      position: "relative",
    }}
  >
      <Table
        columns={columns}
        dataSource={data.reverse()}
        bordered
        scroll={{ x: 'max-content' }}
        rowKey="id"
      pagination={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50"],
        showTotal: (total) => `Total ${total} items`,
      }}
      onChange={handleTableChange}
      />
      </div>
    </Card>
  );
};

export default AllServiceCenters;